// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getFirestore, doc, getDoc, addDoc, updateDoc, collection, serverTimestamp } from 'firebase/firestore'
import { updateCloneCard } from '@/api/FirebaseTreesWrapper.js'
import { getMyUserId } from '@/api/FirebaseUserWrapper'

const db = getFirestore(firebaseApp)

/**
 * Board関係
 */

export async function addCard (team, treeId, nodeId, number, marker, question) {
  const userId = await getMyUserId()
  const teamId = team
  const cardData = {
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    userId: userId,
    treeId: treeId,
    nodeId: nodeId,
    nodeNumber: number,
    question: question,
    marker: marker,
    isDeleted: false
  }
  const boardRef = collection(db, 'teams/' + teamId + '/boards')
  const boardPath = await addDoc(boardRef, cardData)
  return boardPath
}

export async function deleteCard (cardId, teamId) {
  const cardData = {
    updatedAt: serverTimestamp(),
    isDeleted: true
  }
  const docRef = doc(db, 'teams/' + teamId + '/boards', cardId)

  // cloneの存在確認
  const docSnapshot = await getDoc(docRef)
  if (!docSnapshot.exists()) {
    // すでに別treeで消費済み
    return null
  }
  const targetCard = docSnapshot.data()
  try {
    // カードのDelete
    const cardRef = await updateDoc(docRef, cardData)
    // コピー元のtreeのclipを削除
    if (targetCard.treeId && targetCard.nodeId) {
      await updateCloneCard(targetCard.treeId, targetCard.nodeId, null)
    }
    return cardRef
  } catch (err) {
    console.error(err)
    throw err
  }
}

/**
 * _updateCard:
 *   teams/{teamId}/boards/{cardId} を更新する
 *   updatedAt のタイムスタンプは自動で付与する
 * @param {string} teamId
 * @param {string} cardId
 * @param {object} cardData
 * @returns
 */
async function _updateCard (teamId, cardId, cardData) {
  if (typeof (cardData) !== 'object') {
    return null
  }
  cardData.updatedAt = serverTimestamp()
  const cardDocRef = doc(db, 'teams/' + teamId + '/boards', cardId)
  try {
    const cardRef = await updateDoc(cardDocRef, cardData)
    return cardRef
  } catch (err) {
    throw err
  }
}

/**
 * updateCardMarker:
 *   card の marker を更新する
 * @param {string} teamId
 * @param {string} cardId
 * @param {string} marker
 * @returns
 */
export async function updateCardMarker (teamId, cardId, marker) {
  const cardData = {
    marker: marker
  }
  try {
    const cardRef = await _updateCard(teamId, cardId, cardData)
    return cardRef
  } catch (err) {
    throw err
  }
}

/**
 * updateCardText:
 *   node の text を更新する
 * @param {string} teamId
 * @param {string} cardId
 * @param {string} text
 * @returns
 */
export async function updateCardText (teamId, cardId, question) {
  const cardData = {
    question: question
  }
  try {
    const cardRef = await _updateCard(teamId, cardId, cardData)
    return cardRef
  } catch (err) {
    throw err
  }
}

/**
 * updateCardTextAndMarker:
 *   node の text を更新する
 * @param {string} teamId
 * @param {string} cardId
 * @param {string} text
 * @param {string} marker
 * @returns
 */
export async function updateCardTextAndMarker (teamId, cardId, question, marker) {
  const cardData = {
    question: question,
    marker: marker
  }
  try {
    const cardRef = await _updateCard(teamId, cardId, cardData)
    return cardRef
  } catch (err) {
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/api/FirebaseBoardWrapper.js